const decodeApiMessage = (payload: any) => {
  if (payload.errors) return payload.errors.join();
  if (payload.message) return payload.message;
  return null;
};

export default decodeApiMessage;
